import * as PIXI from 'pixi.js';
import {pixiComponents} from "../index";
import {AnimatedSprite, isMobile} from "pixi.js";
import {CANVAS} from "../constants/configs";
import {t, TKeys} from "../translationService";
import {getAmountWithCurrency, universalClick} from "../utilites";
import {boardMatrixExample, freeBetsStore, freeSpinStore, spinStore, store} from "../store";
import {postBuyFreeSpins, postBuyFreeSpinsDemo} from "../api";
import {demoSpinResponseHandler, spinErrorHandler, spinResponseHandler} from "../socketService/responseHandlers";
import {spinControlPanel, spinReels} from "../slotBoard/spin";
import {hideAutoBetSelector, startAutoSpin, stopAutoSpin} from "../controlPanel/autoSpin";
import {showBonusBackground} from "../slotBoard/createSlotBoard";
import {showQuestionModalBuyFreeSpins} from "./questionModalBuyFreeSpins";
import {setBonusWinAmountBoardAmount, showBonusWinAmountBoard} from "./bounsWinAmountBoard";
import {gsap} from "gsap";
import {updateSpinBtnState} from "../controlPanel";
import {updateCanvasSize} from "../../App";
import {spriteSheetAssets} from "../slotBoard/spriteSheetAssets";

export * from "./bounsWinAmountBoard";

export const buyFreeSpins = async () => {
    if (spinControlPanel.isSpinning) {
        return;
    }

    spinStore.setIsQuickFall(false);
    spinControlPanel.isSpinning = true;
    updateSpinBtnState(spinControlPanel);

    await pixiComponents.slotBoard.clear();

    const buyFreeSpinData = {gameId: store.gameId, amount: spinStore.spinAmount};
    if (store.isDemo()) {
        try {
            const result = await postBuyFreeSpinsDemo(buyFreeSpinData);
            demoSpinResponseHandler(result.data);
            setBuyFreeBetBoardVisible(false);
            spinStore.setUserBalance(spinStore.userBalance - spinStore.spinAmount * 100);

        } catch (error) {
            spinErrorHandler(error.response.data.errorMessage);
        }
    } else {
        try {
            const result = await postBuyFreeSpins(buyFreeSpinData);
            spinResponseHandler(result.data);
            setBuyFreeBetBoardVisible(false);
            spinStore.setUserBalance(spinStore.userBalance - spinStore.spinAmount * 100);
        } catch (error) {
            spinErrorHandler(error.response.data.errorMessage);
        }
    }

}

export const startBonusGame = () => {
    spinControlPanel.isAutoSpinning = false;
    spinStore.setAutoSpinCountdown(0);
    updateSpinBtnState(spinControlPanel);
    pixiComponents.slotBoard.multipliersBoard.totalMultiplayerComponent.setTransparency(1);

    showTextWinFreeSpins(`${t(TKeys.YOU_WON_FREE_SPIN, freeSpinStore.freeSpin.quantity)}`);
    freeSpinStore.setIsBonusGameStarted(true);
    showBonusBackground();
    freeSpinStore.setBonusGameWinAmount(store.lastWinAmount);
    setBonusWinAmountBoardAmount(getAmountWithCurrency(store.lastWinAmount, store.currency));
    showBonusWinAmountBoard();
    pixiComponents.slotBoard.setBonusBackground();
}

export const buyFreeSpinsBoardConfigs = {
    width: 199,
    height: 125,
    x: isMobile.phone ? (CANVAS.width - 199 * 0.85) / 2 : 83,
    y: isMobile.phone ? 511 : 185,
}

export const addBuyFreeSpinsBoard = () => {
    const buyFreeSpinsBoard = new PIXI.Container();
    buyFreeSpinsBoard.x = buyFreeSpinsBoardConfigs.x;
    buyFreeSpinsBoard.y = buyFreeSpinsBoardConfigs.y;

    const bg = new PIXI.Sprite(PIXI.Texture.from("./assets/buyFreeSpinsBg.webp"))
    bg.width = buyFreeSpinsBoardConfigs.width;
    bg.height = buyFreeSpinsBoardConfigs.height;

    const buyFreeSpinsTitle = new PIXI.Text(t(TKeys.BUY_FREE_SPINS), titleTextStyle);
    buyFreeSpinsTitle.anchor.set(0.5, 1);
    buyFreeSpinsTitle.x = buyFreeSpinsBoardConfigs.width / 2;
    buyFreeSpinsTitle.y = 62;

    const freeBetPriceText = new PIXI.Text(getAmountWithCurrency(100 * spinStore.spinAmount), priceTextStyle);
    freeBetPriceText.anchor.set(0.5, 0);
    freeBetPriceText.x = buyFreeSpinsBoardConfigs.width / 2;
    freeBetPriceText.y = 70;

    buyFreeSpinsBoard.addChild(bg);
    buyFreeSpinsBoard.addChild(buyFreeSpinsTitle);
    buyFreeSpinsBoard.addChild(freeBetPriceText);
    pixiComponents.app.stage.addChild(buyFreeSpinsBoard);
    pixiComponents.buyFreeSpinsBoard = buyFreeSpinsBoard;
    pixiComponents.freeBetPriceText = freeBetPriceText;
    addMouseEvents();
}

export const setBuyFreeBetBoardClickable = (isClickable) => {
    pixiComponents.buyFreeSpinsBoard.eventMode = isClickable ? 'static' : 'auto';
}

export const setBuyFreeBetBoardVisible = (bool) => {
    pixiComponents.buyFreeSpinsBoard.visible = bool;
}


const bookFrames = [
    "./assets/spriteSheetsFrames/book/0.webp", "./assets/spriteSheetsFrames/book/1.webp",
    "./assets/spriteSheetsFrames/book/2.webp", "./assets/spriteSheetsFrames/book/3.webp",
    "./assets/spriteSheetsFrames/book/4.webp", "./assets/spriteSheetsFrames/book/5.webp",
    "./assets/spriteSheetsFrames/book/6.webp", "./assets/spriteSheetsFrames/book/7.webp",
    "./assets/spriteSheetsFrames/book/8.webp", "./assets/spriteSheetsFrames/book/9.webp",
];

const openBookArr = [];
const closeBookArr = [];

for (let i = 0; i < bookFrames.length; i++) {
    const texture = PIXI.Texture.from(bookFrames[i]);
    openBookArr.push(texture);
    closeBookArr.unshift(texture);
}

export const addTextWinFreeSpins = () => {
    const winFreeSpinNotification = new PIXI.Container();
    const background = new PIXI.Graphics();
    background.beginFill("rgba(0,0,0,0.6)");
    background.drawRect(0, 0, 1500, 1500);
    background.endFill();

    const backgroundImage = new PIXI.Sprite(PIXI.Texture.from("./assets/buyFreeSpinsModalBg.webp"));
    backgroundImage.anchor.set(0.5);
    backgroundImage.position.set(CANVAS.width / 2, CANVAS.height / 2.4);
    backgroundImage.scale.set(0.85, 0.85);


    const winFreeSpinsText = new PIXI.Text(`${t(TKeys.YOU_WON_FREE_SPIN, 10)}`, winFreeSpinTextStyle);
    winFreeSpinsText.anchor.set(0.5);
    winFreeSpinsText.x = CANVAS.width / 2;
    winFreeSpinsText.y = CANVAS.height / 2;
    winFreeSpinsText.alpha = 0;

    winFreeSpinNotification.eventMode = 'static';
    universalClick(winFreeSpinNotification, () => {
        hideTextWinFreeSpins();
        if (freeSpinStore.isBonusGameStarted) {
            startAutoSpin(freeSpinStore.freeSpin.quantity - freeSpinStore.freeSpin.usedQuantity - 1);
        }
    })

    const bookAnimatedSprite = new AnimatedSprite(openBookArr);
    bookAnimatedSprite.scale.set(0.9);
    bookAnimatedSprite.anchor.set(0.5);
    bookAnimatedSprite.animationSpeed = 0.7;
    bookAnimatedSprite.x = CANVAS.width / 2;
    bookAnimatedSprite.y = CANVAS.height / 2.1;
    bookAnimatedSprite.loop = false;
    bookAnimatedSprite.play();

    winFreeSpinNotification.addChild(background, bookAnimatedSprite,/*backgroundImage,*/ winFreeSpinsText);

    pixiComponents.app.stage.addChild(winFreeSpinNotification);
    pixiComponents.bookAnimatedSprite = bookAnimatedSprite;
    pixiComponents.winFreeSpinsText = winFreeSpinsText;
    pixiComponents.winFreeSpinNotification = winFreeSpinNotification;
    pixiComponents.winFreeBackgroundImage = backgroundImage;

    pixiComponents.winFreeSpinNotification.visible = false;
}

export const showTextWinFreeSpins = (text) => {
    pixiComponents.winFreeSpinNotification.visible = true;
    pixiComponents.bookAnimatedSprite.reverse = false;
    pixiComponents.bookAnimatedSprite.textures = openBookArr;
    pixiComponents.bookAnimatedSprite.gotoAndPlay(0);
    pixiComponents.winFreeSpinsText.text = text;
    pixiComponents.bookAnimatedSprite.onComplete = () => {
        gsap.to(pixiComponents.winFreeSpinsText, {
            alpha: 1, duration: 0.2,
            onComplete: () => {
                pixiComponents.bookAnimatedSprite.onComplete = () => {
                };
            }
        })
    }
}

export const hideTextWinFreeSpins = () => {
    pixiComponents.winFreeSpinNotification.eventMode = "none";
    gsap.to(pixiComponents.winFreeSpinsText, {
        alpha: 0, duration: 0.2, onComplete: () => {
            pixiComponents.bookAnimatedSprite.textures = closeBookArr;
            pixiComponents.bookAnimatedSprite.play();
            gsap.to(pixiComponents.winFreeSpinNotification, {
                alpha: 0,
                duration: 0.7,
                onComplete: () => {
                    pixiComponents.winFreeSpinNotification.visible = false;
                    pixiComponents.winFreeSpinNotification.alpha = 1;
                    pixiComponents.winFreeSpinNotification.eventMode = 'static';
                }
            })
        }
    })
}

export const updateFreeBetBoard = () => {
    const buyFreeSpinsBoard = pixiComponents.buyFreeSpinsBoard;
    pixiComponents.freeBetPriceText.text = getAmountWithCurrency(100 * spinStore.spinAmount, store.currency);

    if (100 * spinStore.spinAmount > spinStore.userBalance || spinControlPanel.isSpinning  || freeBetsStore.freeBet) {
        buyFreeSpinsBoard.eventMode = 'auto';
        buyFreeSpinsBoard.alpha = 0.65;
    } else {
        buyFreeSpinsBoard.eventMode = 'static';
        buyFreeSpinsBoard.alpha = 0.95;
    }
}

const addMouseEvents = () => {
    const buyFreeSpinsBoard = pixiComponents.buyFreeSpinsBoard;

    buyFreeSpinsBoard.eventMode = 'static';
    buyFreeSpinsBoard.cursor = 'pointer';

    const setDefaultOpacity = () => pixiComponents.buyFreeSpinsBoard.alpha = 0.95;
    const setNonOpacity = () => pixiComponents.buyFreeSpinsBoard.alpha = 1;

    universalClick(buyFreeSpinsBoard, showQuestionModalBuyFreeSpins);

    buyFreeSpinsBoard.on('mousedown', setDefaultOpacity);
    buyFreeSpinsBoard.on('mouseup', setNonOpacity);
    buyFreeSpinsBoard.on('mouseover', setNonOpacity);
    buyFreeSpinsBoard.on('mouseout', setDefaultOpacity);
    buyFreeSpinsBoard.on('touchstart', setNonOpacity);
    buyFreeSpinsBoard.on('touchend', setDefaultOpacity);
}

const textStyle = {
    fontFamily: 'BebasNeue',
    fill: ['#ECC067', '#F9F0C8', '#B37E3D'],
    stroke: 'rgb(31,31,31)',
    strokeThickness: 2,
    dropShadow: true,
    dropShadowColor: 'rgba(0,0,0)',
    dropShadowBlur: 5,
    dropShadowAngle: Math.PI / 4,
    wordWrap: true,
    wordWrapWidth: buyFreeSpinsBoardConfigs.width,
    align: 'center',
    lineJoin: 'round',
};

const titleTextStyle = new PIXI.TextStyle({
    fontFamily: 'BebasNeue',
    fill: ['#ffffff', '#d5d5d5'],
    // stroke: 'rgb(182,134,0)',
    // strokeThickness: 2,
    // dropShadow: true,
    // dropShadowColor: 'rgb(182,132,0)',
    // dropShadowBlur: 5,
    // dropShadowAngle: Math.PI / 4,
    wordWrap: true,
    wordWrapWidth: buyFreeSpinsBoardConfigs.width,
    align: 'center',
    lineJoin: 'round',
    fontSize: 27,
});

const priceTextStyle = new PIXI.TextStyle({...titleTextStyle, fontSize: 33});

const winFreeSpinTextStyle = new PIXI.TextStyle({
    fontFamily: 'BebasNeue',
    fontWeight: 500,
    fill: ['#ffffff', '#c0c0c0'],
    dropShadow: true,
    dropShadowColor: 'rgba(0,0,0,0.8)',
    dropShadowBlur: 3,
    dropShadowAngle: Math.PI / 4,
    dropShadowDistance: 0,
    fontSize: 90,
    wordWrapWidth: CANVAS.width * 1.8,
    align: 'center',
});